import "../assets/styles/sass/view-jobs.scss";
import axios from "axios";
import { useState, useEffect } from "react";

const ViewJobs = () => {
	const [jobs, setJobs] = useState([]);

	useEffect(() => {
		const getAllJobs = () => {
			axios.get("https://job-boarrd.herokuapp.com/getAllJobs").then((res) => {
				const jobs = res.data;
				const newJob = jobs.reduce((acc, job) => {
					acc[job.jobTitle] = job;
					return acc;
				}, {});
				setJobs(newJob);
				console.log(newJob);
			});
		};
		getAllJobs();
	}, []);

	return (
		<div className="view-jobs">
			<div className="view-job-container">
				<h1>View Jobs</h1>
				<table>
					<thead>
						<tr>
							<th>Company Name</th>
							<th>Job Title</th>
							<th>Job Description</th>
							<th>Job Type</th>
							<th>Salary Range</th>
						</tr>
					</thead>
					<tbody>
						{Object.keys(jobs).map((job) => (
							<tr key={jobs[job]._id}>
								<td>{jobs[job].companyName}</td>
								<td>{jobs[job].jobTitle}</td>
								<td>{jobs[job].jobDescription}</td>
								<td>{jobs[job].jobType}</td>
								<td>{jobs[job].salaryRange}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ViewJobs;
